module.exports = __webpack_public_path__ + "img/call.cf0d4610.png";